import { safeFetch } from "../utils/safeFetch";

const authHeaders = (token, tenant) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
  "x-tenant-id": tenant,
  "Cache-Control": "no-cache, no-store, must-revalidate",
  Pragma: "no-cache",
  Expires: "0",
});

const readErrorMessage = async (response) => {
  const fallback = `HTTP error! status: ${response.status}`;
  try {
    const payload = await response.json();
    return payload?.error || payload?.message || fallback;
  } catch (_) {
    try {
      const text = await response.text();
      return text || fallback;
    } catch (_unusedError) {
      return fallback;
    }
  }
};

export const getTenantSettings = async (token, tenant) => {
  const response = await safeFetch("/api/settings", {
    method: "GET",
    headers: authHeaders(token, tenant),
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(await readErrorMessage(response));
  }

  return response.json();
};

export const updateTenantSettings = async (partialSettings, token, tenant) => {
  const response = await safeFetch("/api/settings", {
    method: "PATCH",
    headers: authHeaders(token, tenant),
    body: JSON.stringify(partialSettings),
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(await readErrorMessage(response));
  }

  return response.json();
};

export const uploadTenantLogo = async (file, token, tenant) => {
  const formData = new FormData();
  formData.append("logo", file);

  const response = await safeFetch("/api/settings/logo", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: formData,
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(await readErrorMessage(response));
  }

  return response.json();
};

export const deleteTenantLogo = async (token, tenant) => {
  const response = await safeFetch("/api/settings/logo", {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(await readErrorMessage(response));
  }

  return response.json();
};
